import { RetailMatchIndexColor } from "../Enums/RetailMatchIndexColor";
import { IRGBColorObject } from "../Models/Models";
import { getRetailMatchMetricTierLevel } from "./RetailMatch/RetailMatchUtil";
import { RetailMatchMetricTier } from "../Enums/RetailMatchMetricTier";

export const hexToRgb = (hex: string): IRGBColorObject | null => {
    const result: RegExpExecArray
    = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
        }
        : null;
};

export const rgbToHex = (r: number, g: number, b: number): string =>
    `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;

export const getRetailMatchIndexColor = (index: number): string => {
    let color: string = RetailMatchIndexColor.red;
    const tierLevel: RetailMatchMetricTier = getRetailMatchMetricTierLevel(index);

    switch (tierLevel) {
        case RetailMatchMetricTier.Tier1: {
            color = RetailMatchIndexColor.red;
            break;
        }
        case RetailMatchMetricTier.Tier2: {
            color = RetailMatchIndexColor.yellow;
            break;
        }
        case RetailMatchMetricTier.Tier3: {
            color = RetailMatchIndexColor.lightGreen;
            break;
        }
        case RetailMatchMetricTier.Tier4: {
            color = RetailMatchIndexColor.green;
            break;
        }
    }

    return color;
};
